module.exports = __webpack_public_path__ + "img/20200102154637321.a4e1959a.jpg";